<template>
  <div class="SELECT-BOX">
    <select
        class="SELECT-INPUT input"
        v-model="selectValue"
        @change="onInput">
      <option v-for="(opt, index) in options" :key="index" :value="getOptionValue(opt)">
        {{getOptionLabel(opt)}}
      </option>
    </select>
    <div class="BAR">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'select-box',
  props: {
    /**
     * 1.- value prop is NOT REQUIRED. it is a helper for when parent component is using v-model
     *
     * 2.- options: array or list of options
     *
     * 3.- optionLabel: is NOT REQUIRED if options is an array of string.
     *
     * 4.- optionLabel:  is REQUIRED if options is an array of object; therefore,
     *     the parent component must declare which property is the label for each option.
     *
     * 5.- optionValue:
     *    When options is a array of object:
     *        - if SET, the value of the prop defined in optionValue is set as value for each option.
     *        - if NOT SET, the full object is set as the value for each option.
    */
    value: {
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    optionLabel: {
      type: String,
      default: null,
    },
    optionValue: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      selectValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.selectValue = val;
      },
    },
  },
  methods: {
    onInput () {
      this.$emit('input', this.selectValue);
      this.$emit('change', this.selectValue);
    },
    getOptionValue (data) {
      if (typeof data === 'object' && this.optionValue) {
        return data[this.optionValue];
      }
      return data;
    },
    getOptionLabel (data) {
      if (typeof data === 'string') {
        return data;
      }
      if (this.optionLabel) {
        return data[this.optionLabel];
      }
      return '- -';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .SELECT-BOX {
    position: relative;
    box-shadow: 0px -3px 1px $color-gray40 inset;
  }
  .SELECT-INPUT {
    background-image: url('../WorkArea/assets/chevrondown-depot.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: padding-box;
    padding-right: 32px;
    background-size: 12px 18px;
    background-position: right 1.5*$unit center;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-repeat: no-repeat;
    background-origin: padding-box;
    border: 1px solid #9CA0A5;
  }
  .BAR {
    border-left: 1px solid #9CA0A5;
    position: absolute;
    left: calc(100% - 40px);
    top: 50%;
    transform: translateY(-50%);
  }
</style>
